
<script>
export default {
  name: 'search-form-tabs',
  data: () => ({
    activeTab: 'HotelsSearch'
  }),
  methods: {
    onChange(tabName) {
      this.activeTab = tabName
      this.$emit('onTabChange', tabName)
    }
  }
}
</script>

<template>
  <div class="search-form__menu">
    <a
      href="javascript:;"
      class="search-form__menu-item"
      :class="{ 'active root-active': activeTab === 'ToursSearch' }"
      @click="onChange('ToursSearch')"
    >
      Туры
    </a>
    <a
      href="javascript:;"
      class="search-form__menu-item"
      :class="{ 'active root-active': activeTab === 'HotelsSearch' }"
      @click="onChange('HotelsSearch')"
    >
      Отели
    </a>
    <a
      href="javascript:;"
      class="search-form__menu-item"
      :class="{ 'active root-active': activeTab === 'FitRequest' }"
      @click="onChange('FitRequest')"
    >
      FIT
    </a>
  </div>
</template>
